import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "user-card d-flex flex-column align-items-stretch mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "next-user"
}
const _hoisted_3 = { class: "avatar ratio ratio-1x1 rounded-circle border border-1 w-50 mx-auto placeholder-glow" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card flex-grow-1 -small" }
const _hoisted_6 = { class: "user-type" }
const _hoisted_7 = {
  key: 0,
  class: "fas fa-angle-double-up fa-lg text-success"
}
const _hoisted_8 = {
  key: 1,
  class: "fas fa-donate fa-lg text-warning"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "avatar ratio ratio-1x1 rounded-circle border border-1 w-50 mx-auto" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "card flex-grow-1 -small" }
const _hoisted_13 = { class: "user-type" }
const _hoisted_14 = {
  key: 0,
  class: "fas fa-angle-double-up fa-lg text-success"
}
const _hoisted_15 = {
  key: 1,
  class: "fas fa-donate fa-lg text-warning"
}
const _hoisted_16 = { class: "card-body p-0 mx-2 mt-4 mb-3 overflow-hidden" }
const _hoisted_17 = { class: "card-text" }
const _hoisted_18 = { class: "d-flex justify-content-center" }
const _hoisted_19 = { class: "d-flex align-items-center me-2" }
const _hoisted_20 = { class: "d-flex flex-column text-center lh-1 text-nowrap" }
const _hoisted_21 = { class: "fw-bold mb-0" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "card-footer text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.userData._usernamePK == '**_next_**')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.profilePictureUrl,
              alt: "Siguiente usuario",
              class: "placeholder rounded-circle img-fluid"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.userData.isPassUp)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : (_openBlock(), _createElementBlock("i", _hoisted_8))
            ]),
            _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"card-body p-0 mx-2 mt-4 mb-3 overflow-hidden\" data-v-66ea7ad0><div class=\"card-text\" data-v-66ea7ad0><div class=\"d-flex justify-content-center\" data-v-66ea7ad0><div class=\"d-flex align-items-center me-2\" data-v-66ea7ad0><i class=\"fas fa-question fa-lg fa-fw\" data-v-66ea7ad0></i></div><div class=\"d-flex flex-column text-center lh-1 text-nowrap col-5\" data-v-66ea7ad0><div class=\"fw-bold mb-0 placeholder-wave\" data-v-66ea7ad0><span class=\"placeholder w-100\" data-v-66ea7ad0></span></div><div class=\"placeholder-wave\" data-v-66ea7ad0><span class=\"placeholder w-75\" data-v-66ea7ad0></span></div></div><div class=\"ms-2\" data-v-66ea7ad0><i class=\"fas fa-lg fa-fw\" data-v-66ea7ad0></i></div></div></div></div><div class=\"card-footer text-center lh-1\" data-v-66ea7ad0><span class=\"\" data-v-66ea7ad0> </span></div>", 2))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: {
            path: '/acelerador',
            query: { _u: _ctx.userData._usernamePK },
          },
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.profilePictureUrl,
                  alt: _ctx.userData._usernamePK,
                  class: "rounded-circle img-fluid gtr-avatar-bg"
                }, null, 8, _hoisted_11)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.userData.isPassUp)
                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                : (_openBlock(), _createElementBlock("i", _hoisted_15))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_rank_icon, {
                      "icon-class": _ctx.userData.rankIconClass,
                      "extra-class": "fa-lg fa-fw"
                    }, null, 8, ["icon-class"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_router_link, {
                      to: {
                    path: '/acelerador',
                    query: { _u: _ctx.userData._usernamePK },
                  },
                      class: "user-drilldown-link"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.userData.nickname), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.userData.username), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ms-2" }, [
                    _createElementVNode("i", { class: "fas fa-lg fa-fw" })
                  ], -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.userInitialDate), 1)
          ])
        ]))
  ]))
}